import * as React from "react";
import { css, PrimaryButton, Label } from "office-ui-fabric-react";
import "./../../Styles/Access.scss";
import ReCAPTCHA from "react-google-recaptcha";
import { errorLabelStyles } from "../../Models/Constant";

interface ICaptchaAndSubmitActionProps {
	isCaptchaValid: boolean;
	onRecaptchaToken: (token: string) => void;
	onButtonClicked: (event: any) => void;
	buttonTitle: string;
	isSubmitProcessing: boolean;
	refReCaptchaRegister: any;
}

export const CaptchaAndSubmitAction = (props: ICaptchaAndSubmitActionProps) => {
	const { onRecaptchaToken, isCaptchaValid, onButtonClicked, isSubmitProcessing, refReCaptchaRegister, buttonTitle } = props;
	return (
		<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "24px", flexWrap: "wrap", width: "100%", marginTop: "24px", paddingRight: "15px" }}>
			<div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
				<ReCAPTCHA
					sitekey="6LfB5BQgAAAAABaHfIoaG-gU0_WFjZggiNzNTLnP"
					onChange={(token: string) => {
						onRecaptchaToken(token);
					}}
					ref={refReCaptchaRegister}
					onExpired={() => onRecaptchaToken("")}
					onErrored={() => onRecaptchaToken("")}
				/>
				{!isCaptchaValid && (
					<Label
						styles={{
							root: errorLabelStyles,
						}}
					>
						Please click on "I'm not a robot"
					</Label>
				)}
			</div>
			<div style={{ display: "flex", alignSelf: "center" }}>
				<PrimaryButton
					text={buttonTitle}
					onClick={onButtonClicked}
					disabled={isSubmitProcessing}
					styles={{
						root: {
							height: "48px",
							borderRadius: "8px",
							fontWeight: 600,
							textTransform: "uppercase",
							letterSpacing: "0.04em",
							background: "#047348",
							border: "none",
							padding: "0 24px",
							minWidth: "180px",
						},
						rootHovered: {
							background: "#00a46b",
						},
						rootPressed: {
							background: "#035a38",
						},
						label: {
							color: "#ffffff"
						}
					}}
				/>
			</div>
		</div>
	);
};
